import axios from 'axios'
import {serialize} from '@/util/util'
import {getStore, setStore} from '@/util/store'
import NProgress from 'nprogress' // progress bar
import errorCode from '@/const/errorCode'
import router from '@/router/router'
import {Message} from 'element-ui'
import 'nprogress/nprogress.css'
import qs from 'qs'
import store from '@/store' // progress bar style
import versionConfig from '@/../version.json'
import {validatenull} from '@/util/validate'
import {getSecretData} from '@/util/commonUtils'
import channelDif from '@/util/channelUtil'
import {getDiffEnvConfig} from '@/config/env'
import _ from 'lodash'
import {isBxMeidiGuangfu} from '@/config/env'

axios.defaults.timeout = 10000 * 1000
// 返回其他状态吗
axios.defaults.validateStatus = function (status) {
	return status >= 200 && status <= 500 // 默认的
}
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true
// NProgress Configuration
NProgress.configure({
	showSpinner: false,
})

// HTTPrequest拦截
axios.interceptors.request.use(
	(config) => {
		NProgress.start() // start progress bar
		//获取请求头
		return getRequestHeaders(config)
	},
	(error) => {
		return Promise.reject(error)
	},
)

// HTTPresponse拦截
axios.interceptors.response.use(
	async (res = {}) => {
		NProgress.done()
		//没有数据返回，直接报错
		if (validatenull(res) || validatenull(res.status)) {
			return Promise.reject(new Error('当前网络不稳定，计算保费超时，请稍后再重试！'))
		}
		// convert blob to json if needed
		if (res.data && res.data instanceof Blob && res.data.type == 'application/json') {
			let result = await res.data.text()
			if (result) {
				res.data = JSON.parse(result)
			}
		}
		const status = Number(res.status) || 200
		let message = res.data.msg || errorCode[status] || errorCode['default']
		//替换所有换行符
		message = message.replaceAll('\n', '<br/>')

		if (status === 401) {
			handle401Func()
			return
		}
		if (status !== 200 || res.data.code === 1) {
			let url = res.config.url
			if (url.indexOf('distInsure/payStatus') === -1 && url.indexOf('insure/verify_holder') === -1) {
				//替换接口要获取初始数据
				Message({
					message: message,
					dangerouslyUseHTMLString: true,
					type: 'error',
				})
			}
			if (
				url.indexOf('distInsure/batchModify') !== -1 ||
				url.indexOf('service/batch/add') !== -1 ||
				url.indexOf('insure/verify_holder') !== -1 ||
				url.indexOf('/v2') !== -1
			) {
				return res
			}
			return Promise.reject(new Error(message))
		}
		return res
	},
	(error) => {
		// 处理 503 网络异常
		if (error.response && error.response.status == 503) {
			Message({
				message: error.response.data.msg,
				dangerouslyUseHTMLString: true,
				type: 'error',
			})
		}
		NProgress.done()
		return Promise.reject(new Error(error))
	},
)

export default axios

/**
 * 统一处理请求头
 */
export function getRequestHeaders(config = {}) {
	let {headers = {}, method = '', data = {}, url = ''} = config
	let {isToken = false} = headers
	//token
	let token = getStore({name: 'access_token'})
	if (token && !isToken) {
		headers['Authorization'] = 'Bearer ' + token
	}
	let {VUE_APP_CHANNELID: TenantId = '', VUE_APP_APPID: appId = ''} = getDiffEnvConfig()
	// 租户ID
	if (TenantId) {
		headers['TENANT-ID'] = TenantId
	}
	//获取不同渠道appid
	let appIdTemp = channelDif.getDifChannelAppId(url)
	if (appIdTemp) {
		appId = appIdTemp
	}
	if (appId) {
		headers['appid'] = appId
	}
	//版本号
	headers['version'] = versionConfig.version || ''
	headers['versionTime'] = versionConfig.date || ''
	//额外请求头加密
	let [sTitle, sValue] = getSecretData()
	headers[sTitle] = sValue
	// headers中配置serialize为true开启序列化
	if (method === 'post' && headers.serialize) {
		config.data = serialize(data)
		delete config.data.serialize
	}
	if (method === 'get') {
		config.paramsSerializer = (params) => {
			return qs.stringify(params, {arrayFormat: 'repeat'})
		}
	}
	config.headers = headers
	return config
}

const handle401Func = _.throttle(handle401, 3000)

//401 跳转登录界面
function handle401() {
	//使用lodash 立即执行后，1000ms内不再执行
	console.log('handle401----------')
	Message({
		message: `用户凭证已过期，请重新登录!`,
		dangerouslyUseHTMLString: true,
		type: 'error',
	})
	//美的光伏不跳转
	if (isBxMeidiGuangfu()) {
		return
	}
	store.dispatch('LogOut').then(() => {
		setStore({name: 'login', content: {forceRefresh: true}})
		router.push({path: '/login'})
	})
}
